<template>
  <button
    type="button"
    class="btn btn-success c-rounded-pill c-p-3 c-sm:c-p-2 font-medium whitespace-nowrap w-100 relative z-2"
    :class="widthClass"
    aria-label="Push to mix"
    @click.prevent="
      openModal({
        id: 'push-to-mix-modal',
        params: {
          permalink: product.permalink,
          categories: product.mixableToCategories,
        },
      })
    "
  >
    <i
      class="mi-mix icon-20"
      :class="[{ 'mr-2 c-sm:c-mr-1': !iconButtonOnly }, addClass]"
    />
    <template v-if="!iconButtonOnly">
      {{ t('add_to_mix') }}
    </template>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useModalStore } from '@/stores/ModalStore'

defineProps({
  product: {
    type: Object,
    required: true,
  },

  widthClass: {
    type: String,
    default: '',
  },

  addClass: {
    type: String,
    default: '',
  },

  iconButtonOnly: {
    type: Boolean,
    default: false,
  },
})

const { openModal } = useModalStore()
const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "add_to_mix": "Do mixu"
},
    "sk": {
    "add_to_mix": "Do mixu"
},
    "pl": {
    "add_to_mix": "Do mieszania"
},
    "hu": {
    "add_to_mix": "Mixbe"
},
    "de": {
    "add_to_mix": "mixen"
},
    "at": {
    "add_to_mix": "mixen"
},
    "ro": {
    "add_to_mix": "În amestec"
},
    "fr": {
    "add_to_mix": "Dans le mix"
},
    "it": {
    "add_to_mix": "Nel mix"
}
  }
</i18n>